export function myProfileGet(item) {
	return {
    type: 'MY_PROFILE_GET',
		payload: {
			item: item,
		},
	}
}

export function myProfileUserSave(user, callback) {
	return {
    type: 'MY_PROFILE_USER_SAVE',
		payload: {
			user: user,
		},
		callback: callback,
	}
}

export function myProfilePartnerSave(partner, callback) {
	return {
    type: 'MY_PROFILE_PARTNER_SAVE',
		payload: {
			partner: partner,
		},
		callback: callback,
	}
}

export function myProfileCommentSave(comment, partnerComment, callback) {
	return {
    type: 'MY_PROFILE_COMMENT_SAVE',
		payload: {
			comment: comment,
			partnerComment: partnerComment,
		},
		callback: callback,
	}
}
